export default (that) => [
  {
    text: that.$l('INDEX.btn_tips_view') || '查看',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('INDEX.btn_tips_edit') || '编辑',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    disabled: ({ reportBudgetStatus }) => reportBudgetStatus !== 'N',
  },
  {
    text: that.$l('INDEX.btn_tips_del') || '删除',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    disabled: ({ reportBudgetStatus }) => reportBudgetStatus !== 'N',
  },
  {
    text: that.$l('INDEX.btn_tips_submit_review') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'check',
    divided: true,
    allow: 'C',
    data: {},
    disabled: ({ reportBudgetStatus }) => reportBudgetStatus !== 'N',
  },
  {
    text: that.$l('btn_tips_adjust') || '调整预算',
    icon: 'el-icon-edit-outline',
    menuType: 'adjust',
    allow: 'J',
    data: {},
    disabled: ({ reportBudgetStatus }) => reportBudgetStatus !== 'Y',
  }
]
